import { Ribbon } from "@components/ui/ecco-club/ribbon";
import { Box } from "@ecco/ui/box";
import { Spacer as _Spacer } from "@ecco/ui/spacer";
import type { SpacerModel } from "@lib/contentful/mappers/modules/spacer/types";
import type { FC } from "react";

export const Spacer: FC<SpacerModel> = ({ size, isECCOClubRibbon }) => {
    if (isECCOClubRibbon) {
        return (
            <Box my={["4", "6", "8"]}>
                <Ribbon />
            </Box>
        );
    }

    return <_Spacer size={size} />;
};
